import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../colorVars';

export const BidLine = ({ dataArray, scaleX, scaleY }) => {
  if (scaleY == null || scaleX === null || dataArray.length < 2) return null;
  return (
    <g stroke={colors.green}>
      {dataArray.map((item, index) => {
        if (index === 0) return null;
        const previousPrice = dataArray[index - 1].bid;
        const currentPrice = item.bid;
        return (
          <line
            key={'' + index + item}
            x1={scaleX(index - 1)}
            x2={scaleX(index)}
            y1={scaleY(previousPrice)}
            y2={scaleY(currentPrice)}
          />
        );
      })}
    </g>
  );
};

BidLine.propTypes = {
  dataArray: PropTypes.array,
  scaleX: PropTypes.func,
  scaleY: PropTypes.func
};
